import SpreeAPI from "./spree/api/storefront/cart"

SpreeAPI.ready(function($) {
  if (!SpreeAPI.apiTokensFetched) SpreeAPI.fetchApiTokens();

  $('#add-to-cart-form').on('submit', '.add-to-cart-form', function(event) {
    var $cartForm = $(event.currentTarget);
    var $addToCart = $cartForm.find('.add-to-cart-form');
    var variantId = $cartForm.find('[name="variant_id"]').val();
    var quantity = parseInt($cartForm.find('[name="quantity"]').val());
    var options = {};
    event.preventDefault();
    $addToCart.prop('disabled', true);
    document.querySelector('#flash_area .l_flash_message').classList.remove('error');
    SpreeAPI.ensureCart(function() {
      SpreeAPI.Storefront.addToCart(
        variantId,
        quantity,
        options,
        function(response) {
          $addToCart.prop('disabled', false)
          SpreeAPI.fetchCart()
          $cartForm.trigger({
            type: 'product_add_to_cart',
            variant: variantId,
            quantity_increment: quantity,
            cart: response.attributes
          })
          if ($cartForm.find('[name="reload"]').length) {
            location.href = '/cart'
          } else {
            document.querySelector('#flash_area .l_flash_message').innerText = 'カートに商品を入れました'
            document.getElementById('flash_area').classList.add('is_active')
            window.setTimeout(function(){
              document.getElementById('flash_area').classList.remove('is_active')
            }, 5000)
          }
        },
        function(error) {
          if (typeof error === 'string' && error !== '') {
            document.querySelector('#flash_area .l_flash_message').innerText = error
            document.querySelector('#flash_area .l_flash_message').classList.add('error')
            document.getElementById('flash_area').classList.add('is_active')
            window.setTimeout(function(){
              document.getElementById('flash_area').classList.remove('is_active')
            }, 5000)
          }
          $addToCart.prop('disabled', false)
        } // failure callback for 422 and 50x errors
      )
    });
  });
})
